
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Editor5 from "@/components/editor/classic-editor5.vue";
import UploadImg from "@/components/UploadImg-ai.vue";
import UploadImgBefore from "@/components/UploadImg-ai.vue";
import UploadImgAfter from "@/components/UploadImg-ai.vue";
import UploadVideo from "@/components/UploadVideo-ai.vue";
import RegisEdit from "../components/regis-edit.vue";
import Pop from "../components/blue-pop.vue";
import Loading from "../../../components/loading.vue";
import SW from "@/components/form/switch.vue";
import SetDiyPage from "../components/set-diy-page.vue";
import myCollapse from "@/views/ai-builder/step-view/components/myCollapse.vue";
import mySetup from "@/views/ai-builder/step-view/components/mySetup.vue";
import request from "@/lib/request/request";

import asideBar from "../components/aside-bar.vue";
import componentFlow from "../components/component-flow.vue";
import globalFunctional from "../components/global-functional.vue";
import previewPhone from "../components/preview-phone.vue";
import previewAssets from "../components/preview-assets.vue";
import deleteDialog from "../components/delete-dialog.vue";

// 引入表单  命名需对应   用于循环创建组件
import handDetection from "@/views/ai-builder-component/forms/handDetection.vue";
import faceDetection from "@/views/ai-builder-component/forms/faceDetection.vue";
import faceAssessment from "@/views/ai-builder-component/forms/faceAssessment.vue";
import colorDetection from "@/views/ai-builder-component/forms/colorDetection.vue";
import appearance from "@/views/ai-builder-component/forms/appearance.vue";
import aiWatchingScreen from "@/views/ai-builder-component/forms/aiWatchingScreen.vue";
import aiWatchingVideo from "@/views/ai-builder-component/forms/aiWatchingVideo.vue";
import aiWatchingAudio from "@/views/ai-builder-component/forms/aiWatchingAudio.vue";
import aiWatchingPolice from "@/views/ai-builder-component/forms/aiWatchingPolice.vue";
import params from "@/views/ai-builder-component/forms/params.vue";
import deviceDetection from "@/views/ai-builder-component/forms/deviceDetection.vue";
import ThousandQuestion from "@/views/ai-builder-component/forms/thousandQuestion.vue";
import Report from "@/views/ai-builder-component/forms/report/report.vue";
import ReportV6 from "@/views/ai-builder-component/forms/report/report-v6.vue";
import examRoomStyle from "@/views/ai-builder-component/forms/examRoomStyle.vue";
import examRoomHr from "@/views/ai-builder-component/forms/examRoomHr.vue";
import examBg from "@/views/ai-builder-component/forms/examBg.vue";
import tacPsycGauge from "@/views/ai-builder-component/forms/tacPsycGauge.vue";
import descConfig from "@/views/ai-builder-component/forms/descConfig.vue";
import AIAnswer from "@/views/ai-builder-component/forms/AiAnswer/index.vue";
import aiAsk from "@/views/ai-builder-component/forms/aiAsk.vue";
import otherSet from "@/views/ai-builder-component/forms/otherSet.vue";
import customPage from "@/views/ai-builder-component/forms/customPage.vue";
import baseInfo from "@/views/ai-builder-component/forms/baseInfo.vue";
import storeSet from "@/views/ai-builder-component/forms/storeSet.vue";
import certPhoto from "@/views/ai-builder-component/forms/certPhoto.vue";
import Signature from "@/views/ai-builder-component/forms/signature.vue";
import loginPage from "@/views/ai-builder-component/forms/loginPage.vue";

import { Vir } from "@/lib/model/exambuilder/exam-v2";
import ReportSet from "../config/reportSet.vue";
import {
  ExamComponent,
  SectionPageType
} from "@/lib/model/exambuilder/exam-component/exam";
import { DimensionGroup } from "@/lib/model/exambuilder/exam-component/dimension";
import { getArmCompleteConfigMessageList } from "@/lib/model/exambuilder/exam-component/component";

import HinaSwitch from "@/views/ai-builder-component/baseComponent/hina-switch.vue";
import { langList } from "@/utils/multi-lang";
import HinaSelect from "../baseComponent/hina-select.vue";

//左侧菜单 结构项
interface From {
  title: string;
  child?: From[];
  level: number;
  isShow: boolean;
  hiddenMenu?: boolean; // 是否隐藏菜单, true 隐藏
  active: boolean;
  componentPageName?: string;
  componentIncludeConfig?: string[];
  icon?: string; // 目前仅六个"全局增强"的tab需要icon
  iconActive?: boolean; // 全局增强图标激活状态
  badge?: boolean; // 需要提示时使用
}
// 全局增强
interface GlobalItem {
  componentPageName: string; // todo 定义个枚举全局统一
  icon: string; // todo 同上
  showName: string;
  active: boolean;
  themeColor: string;
}
//表单页面组件
interface FromPage {
  name: string;
  src?: string;
}

// 体验枚举，定义这里的key和componentpagename的相同
enum EnumTrial {
  ALL = "",
  colorDetection = "colorDetection",
  handDetection = "handDetection",
  faceDetection = "faceDetection",
  tacPsycGauge = "tacPsycGauge",
  aiWatchingScreen = "screenMonitoring",
  aiWatchingVideo = "videoMonitoring",
  AIAnswer = "intelligentQA",
  ThousandQuestion = "thousands",
  aiAsk = "askAppend"
}

@Component({
  components: {
    HinaSelect,
    HinaSwitch,
    Editor5,
    UploadImg,
    RegisEdit,
    UploadVideo,
    Pop,
    Loading,
    appearance,
    UploadImgBefore,
    UploadImgAfter,
    SW,
    asideBar,
    componentFlow,
    globalFunctional,
    previewPhone,
    previewAssets,
    deleteDialog,
    SetDiyPage,
    myCollapse,
    ReportSet,
    mySetup,
    handDetection,
    faceDetection,
    faceAssessment,
    colorDetection,
    tacPsycGauge,
    aiWatchingScreen,
    aiWatchingVideo,
    aiWatchingPolice,
    aiWatchingAudio,
    params,
    descConfig,
    deviceDetection,
    AIAnswer,
    ThousandQuestion,
    Report,
    ReportV6,
    examRoomStyle,
    aiAsk,
    otherSet,
    examRoomHr,
    customPage,
    baseInfo,
    examBg,
    storeSet,
    certPhoto,
    Signature,
    loginPage
  }
})
export default class SetOther extends Vue {
  @Prop({ type: ExamComponent, default: null }) examComponent!: ExamComponent; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答
  @Prop({ default: [new Vir()] }) virList!: Vir[]; //虚拟人list
  @Prop({ default: false }) setWeb!: boolean; //内部使用 web配置
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  //子表单 特殊提交 临时办法
  formItemSubmit(form: FromPage, data: { key: string; value: string }) {
    //一些空表单页面，先放一个input录入json，点击表单内的保存，就存到总数据源
    try {
      const res = JSON.parse(data.value)[data.key];
      Object.entries(res).forEach(([k, v]) => {
        this.$set(this.examComponent.examVersionInfo[data.key], k, v);
      });
    } catch (err) {
      console.error(err);
    }
  }

  langList = langList;

  previewVisible = false;
  previewSrc = "";

  preview(src: string) {
    if (!src) {
      return;
    }
    this.previewSrc = src;
    this.previewVisible = true;
  }

  showFlow = true;
  isDragging = false;

  onDragStart() {
    this.isDragging = true;
  }

  onDragEnd(position: string) {
    if (position === "Before") {
      this.dragComponentListBefore.forEach((item: any, index: number) => {
        item.componentSort = index + this.fixedComponentListBefore.length + 1;
      });
    }
    if (position === "After") {
      this.dragComponentListAfter.forEach((item: any, index: number) => {
        item.componentSort =
          index +
          this.fixedComponentListBefore.length +
          this.dragComponentListBefore.length +
          1;
      });
    }
    if (position === "End") {
      this.dragComponentListEnd.forEach((item: any, index: number) => {
        item.componentSort =
          index +
          this.fixedComponentListBefore.length +
          this.dragComponentListBefore.length +
          this.dragComponentListAfter.length +
          1;
      });
    }

    this.isDragging = false;
  }

  setScorePercent(scorePercent: number) {
    this.examComponent.examVersionInfo.scoreConfig.appendScorePercent = scorePercent;
  }

  // 翻转 + 渐隐
  async turnAndFadeout(duration = 500) {
    const fadeOut = this.$refs.fade as HTMLElement;
    const turnAround = this.$refs.turnAround as HTMLElement;
    if (!fadeOut || !turnAround) {
      return;
    }
    turnAround.animate(
      [{ transform: "rotateY(0)" }, { transform: "rotateY(180deg)" }],
      duration
    );
    const animation = fadeOut.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      duration
    );
    return new Promise(resolve => {
      animation.onfinish = () => {
        fadeOut.classList.add("fade-out");
        resolve(true);
      };
    });
  }

  // 渐进
  async fadeIn(duration = 500) {
    const fadeIn = this.$refs.fade as HTMLElement;
    const animation = fadeIn.animate(
      [{ opacity: 0 }, { opacity: 1 }],
      duration
    );
    return new Promise(resolve => {
      animation.onfinish = () => {
        fadeIn.classList.remove("fade-out");
        resolve(true);
      };
    });
  }

  async checkData() {
    this.setSectionPageForAllLanguages();
    const res = await this.submitAllForm();
    return res.code === 0;
  }

  // !临时方案：在保存的时候补齐一下开启的对应的检测环节的环节介绍文案。
  setSectionPage() {
    // 形体检测对应的环节介绍
    // 中文
    if (this.examComponent.examVersionInfo.lang === 0) {
      // 开启形体检测，且环节介绍名称为空
      if (
        this.examComponent.examVersionInfo.bodyDetection.use === 1 &&
        !this.examComponent.examVersionInfo.bodyDetection.configData
          .sectionPageConfig.sectionName
      ) {
        this.examComponent.examVersionInfo.bodyDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPage(
          SectionPageType.Body
        );
      }
    }
  }

  // !!!临时方案：根据语言设置对应的环节介绍
  setSectionPageForEnglish() {
    // 辨色检测对应的英文环节介绍
    if (this.examComponent.examVersionInfo.lang === 1) {
      if (this.examComponent.examVersionInfo.colorDetection.use === 1) {
        this.examComponent.examVersionInfo.colorDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageForEnglish(
          SectionPageType.Color
        );
      }
      // 主观题/客观题对应的英文环节介绍
      if (this.examComponent.examVersionInfo.questions.use === 1) {
        this.examComponent.examVersionInfo.questions.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageForEnglish(
          SectionPageType.Questions
        );
      }
      // 手部检测对应的英文环节介绍
      if (this.examComponent.examVersionInfo.handDetection.use === 1) {
        this.examComponent.examVersionInfo.handDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageForEnglish(
          SectionPageType.Finger
        );
      }
      // 形体检测对应的英文环节介绍
      if (this.examComponent.examVersionInfo.bodyDetection.use === 1) {
        this.examComponent.examVersionInfo.bodyDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageForEnglish(
          SectionPageType.Body
        );
      }
    }
  }

  // 设置所有语言的环节介绍页
  setSectionPageForAllLanguages() {
    const lang = this.examComponent.examVersionInfo.lang;
    if (lang < 0 || lang > 7) return; // 无效的语言代码

    // 使用统一的方法设置所有语言的环节介绍页
    if (this.examComponent.examVersionInfo.colorDetection.use === 1) {
      this.examComponent.examVersionInfo.colorDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageByLang(
        SectionPageType.Color,
        lang
      );
    }

    // 主观题/客观题对应的环节介绍
    if (this.examComponent.examVersionInfo.questions.use === 1) {
      this.examComponent.examVersionInfo.questions.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageByLang(
        SectionPageType.Questions,
        lang
      );
    }

    // 手部检测对应的环节介绍
    if (this.examComponent.examVersionInfo.handDetection.use === 1) {
      this.examComponent.examVersionInfo.handDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageByLang(
        SectionPageType.Finger,
        lang
      );

      // 更新手部检测文案
      this.examComponent.examVersionInfo.handDetection.configData.noArmCompleteConfigMessageList = getArmCompleteConfigMessageList(
        lang
      );
    }

    // 形体检测对应的环节介绍
    if (this.examComponent.examVersionInfo.bodyDetection.use === 1) {
      this.examComponent.examVersionInfo.bodyDetection.configData.sectionPageConfig = ExamComponent.getDefaultSectionPageByLang(
        SectionPageType.Body,
        lang
      );
    }
  }

  async changeRightType(flag?: boolean) {
    if (this.showFlow !== flag) {
      await this.turnAndFadeout(300);
      this.showFlow = !!flag;
      this.$nextTick(() => {
        this.fadeIn();
      });
    }
  }

  currentFormPageName = "baseInfo";

  getCurrentFromPageName(val: string) {
    this.currentFormPageName = val || "";
  }

  setBar(form: FromPage, badge: boolean) {
    this.sideList.forEach(item => {
      if (item.child && item.child.length > 0) {
        item.child.forEach(child => {
          if (child.componentPageName === form.name) {
            this.$set(child, "badge", badge);
          }
        });
      } else if (item.componentPageName === form.name) {
        this.$set(item, "badge", badge);
      }
    });
  }

  checkDialogShow = false;
  checkTitle = "";
  checkText = "";

  // 校验所有表单
  async checkAllForm(): Promise<boolean> {
    const formResList: string[] = [];
    const allForm = this.$refs["formItem"] as [];
    for (const form of allForm) {
      try {
        // 各组件formItemCheck通过时返回空串，不通过时将本表单的componentPageName返回
        const res = await (form as any)?.formItemCheck();
        if (res) {
          formResList.push(res);
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (formResList.length > 0) {
      Object.keys(this.componentIncludeConfigMap).forEach(item => {
        if (formResList.includes(item)) {
          this.setBar({ name: item }, true);
        } else {
          this.setBar({ name: item }, false);
        }
      });
      this.checkDialogShow = true;
      this.checkTitle = "重新检查";
      this.checkText =
        formResList.map(this.getTitleFromComponentName).join("、") +
        "未通过，请重新检查";
    }
    const that = this as any;
    (function() {
      const asideBar = that.$refs.asideBar as any;
      if (!asideBar) {
        return;
      }
      that.sideList.forEach((item: any, index: number) => {
        if (item.child?.length) {
          item.child.forEach((child: any, childIndex: number) => {
            if (child.componentPageName === formResList[0]) {
              asideBar.clickLeftLv2(child, childIndex, index);
            }
          });
        } else if (item.componentPageName === formResList[0]) {
          asideBar.clickLeftLv1(item, index);
        }
      });
    })();
    return formResList.length <= 0;
  }

  // 所有配置表单 总提交
  async submitAllForm() {
    const res = await this.checkAllForm();

    if (!res) {
      return { code: -10086 };
    }

    // 处理自定义组件排序
    this.examComponent.examVersionInfo.customPageConfigList.forEach(item => {
      switch (item.configData.positionType) {
        case 1: {
          item.sortType = "component";
          item.componentSort =
            this.examComponent.examVersionInfo.descBefore.componentSort - 1;
          break;
        }
        case 2: {
          item.sortType = "component";
          item.componentSort = this.examComponent.examVersionInfo.descBefore.componentSort;
          break;
        }
        case 3: {
          item.sortType = "component";
          item.componentSort =
            this.examComponent.examVersionInfo.params.componentSort - 1;
          break;
        }
        case 4: {
          item.sortType = "component";
          item.componentSort = this.examComponent.examVersionInfo.params.componentSort;
          break;
        }
        case 5: {
          item.componentSort = item.questionSort - 1;
          item.sortType = "question";
          break;
        }
      }
    });

    return { code: 0 };
  }

  // 二级菜单对应的组件内包含的表单
  componentIncludeConfigMap = {
    baseInfo: [
      "timeLimitConfig",
      "repeatAnswerConfig",
      "questions",
      "colorDetection",
      "tacPsycGauge",
      "handDetection",
      "bgCheck",
      "livenessRecognition"
    ], // 基本信息
    colorDetection: ["colorDetection"], //辨色检测
    handDetection: ["handDetection", "bodyDetection"], //手部综合检测
    faceDetection: ["faceDetection"], //脸部综合检测
    faceAssessment: ["faceAssessment"], //颜值检测
    tacPsycGauge: ["tacPsycGauge"], //心理测评
    aiWatchingScreen: ["screenshotDetection", "jumpOutDetection", "watermark"], //屏幕内容监控 截屏检测、切屏检测 （水印）
    aiWatchingVideo: [
      "faceShowDetection",
      "multiplePersonDetection",
      "replacementDetection"
    ], //智能视频监控 露脸 多人 换人
    aiWatchingPolice: [
      "livenessRecognition",
      "params",
      "paramList",
      "allParams",
      "nameIdCheck"
    ], //公安部身份核验
    params: [
      "params",
      "allParams",
      "defaultParams",
      "paramList",
      "paramsSaveLater",
      "bgCheck",
      "livenessRecognition",
      "nameIdCheck"
      // "loginConfig"
    ], //信息收集
    descConfig: [
      "publicityPageConfig",
      "descBefore",
      "descAfter",
      "vrGuideConfig",
      "workLocationConfig"
    ], //面试引导语
    deviceDetection: [
      "deviceDetection",
      "versionDetection",
      "networkDetection"
    ], //设备检测
    certPhoto: ["certPhotoCapture"],
    signature: ["signatureConfig"],
    AIAnswer: ["intelligentQa"], //AI答疑官
    ThousandQuestion: ["questions", "questionSelectedList", "thousandsTask"], //千人千问
    aiAsk: ["questions", "questionSelectedList", "aiAsk"], //智能追问
    //以下是无子项的一级菜单
    examRoomStyle: ["styleConfig"], //面试间风格
    report: ["reportConfig"], //报告页风格
    reportV6: ["reportConfig"], //报告页风格
    customPage: ["customPageConfigList", "questionSelectedList"], //自定义页
    examRoomHr: ["virConfig"], //面试间形象
    examBg: ["bgCheck", "params", "paramList", "allParams"], //背景调查
    storeSet: ["channelConfig"],
    appearance: ["hairDetection", "dressingDetection", "smokeDetection"], //仪容仪表
    aiWatchingAudio: ["keyboardSoundDetection", "multiVoiceDetection"],
    otherSet: [
      "reportConfig",
      "questions",
      "questionSelectedList",
      "timeLimitConfig",
      "virConfig",
      "questionnaireConfig",
      "testExamConfig",
      "resumeParseConfig",
      "readingDetection"
    ], // 其他设置
    loginPage: ["loginConfig"]
  };

  // 需要单个体验的组件
  singlePreviewList = [
    "colorDetection",
    "handDetection",
    "faceDetection",
    "tacPsycGauge",
    "aiWatchingScreen",
    "aiWatchingVideo",
    "AIAnswer",
    "aiAsk"
  ];
  componentPageNameToComponentType(name: string) {
    const obj = {}; // 需要转换的组件类型
    return obj[name] || name;
  }

  getTitleFromComponentName(componentPageName: string) {
    let title = "";
    try {
      [
        ...this.sideList,
        { componentPageName: "baseInfo", title: "基本信息" }
      ].forEach(item => {
        if (item.child?.length) {
          item.child.forEach(child => {
            if (child.componentPageName === componentPageName) {
              title = child.title;
              throw new Error("find");
            }
          });
        } else if (item.componentPageName === componentPageName) {
          title = item.title;
          throw new Error("find");
        }
      });
    } catch (error) {
      console.log(error);
    }
    return title;
  }

  // 左侧菜单数据配置
  sideListConfig: From[] = [
    {
      title: "测评工具",
      level: 1,
      isShow: true,
      componentPageName: "examTool",
      active: false,
      child: [
        {
          title: "辨色检测",
          level: 2,
          isShow: true,
          componentPageName: "colorDetection",
          componentIncludeConfig: this.componentIncludeConfigMap.colorDetection,
          active: false
        },
        {
          title: "形体检测",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "handDetection",
          componentIncludeConfig: this.componentIncludeConfigMap.handDetection,
          active: false
        },
        {
          title: "心理测评",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "tacPsycGauge",
          componentIncludeConfig: this.componentIncludeConfigMap.tacPsycGauge,
          active: false
        },
        {
          title: "面部综合检测",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "faceDetection",
          componentIncludeConfig: this.componentIncludeConfigMap.faceDetection,
          active: false
        },
        {
          title: "颜值检测",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "faceAssessment",
          componentIncludeConfig: this.componentIncludeConfigMap.faceAssessment,
          active: false
        }
      ]
    },
    {
      title: "智能防作弊",
      level: 1,
      isShow: true,
      componentPageName: "aiWatching",
      active: false,
      child: [
        {
          title: "屏幕监控",
          level: 2,
          isShow: true,
          componentPageName: "aiWatchingScreen",
          componentIncludeConfig: this.componentIncludeConfigMap
            .aiWatchingScreen,
          active: false,
          iconActive: false,
          icon: "aiWatching"
        },
        {
          title: "视频监控",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "aiWatchingVideo",
          componentIncludeConfig: this.componentIncludeConfigMap
            .aiWatchingVideo,
          active: false,
          iconActive: false,
          icon: "video"
        },
        {
          title: "音频监控",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "aiWatchingAudio",
          componentIncludeConfig: this.componentIncludeConfigMap
            .aiWatchingAudio,
          active: false,
          iconActive: false,
          icon: "video"
        }
      ]
    },
    {
      title: "登录页配置",
      level: 1,
      isShow: true,
      hiddenMenu: this.builder === "MOKA_V2",
      componentPageName: "loginPage",
      componentIncludeConfig: this.componentIncludeConfigMap.loginPage,
      active: false
    },
    {
      title: "面试前准备",
      level: 1,
      isShow: true,
      componentPageName: "examBefore",
      active: false,
      child: [
        {
          title: "面试引导语",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "descConfig",
          componentIncludeConfig: this.componentIncludeConfigMap.descConfig,
          active: false
        },
        {
          title: "信息收集",
          level: 2,
          isShow: true,
          componentPageName: "params",
          componentIncludeConfig: this.componentIncludeConfigMap.params,
          active: false
        },
        {
          title: "设备检测",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "deviceDetection",
          componentIncludeConfig: this.componentIncludeConfigMap
            .deviceDetection,
          active: false
        },
        {
          title: "身份核验",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "aiWatchingPolice",
          componentIncludeConfig: this.componentIncludeConfigMap
            .aiWatchingPolice,
          active: false,
          iconActive: false
          // icon: "police"
        },
        {
          title: "背景调查",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "examBg",
          componentIncludeConfig: this.componentIncludeConfigMap.examBg,
          active: false,
          iconActive: false
        },
        {
          title: "证件照",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "certPhoto",
          componentIncludeConfig: this.componentIncludeConfigMap.certPhoto,
          active: false
        },
        {
          title: "电子签名",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "signature",
          componentIncludeConfig: this.componentIncludeConfigMap.signature,
          active: false
        }
      ]
    },
    {
      title: "智能工具",
      level: 1,
      isShow: true,
      componentPageName: "aiTool",
      active: false,
      child: [
        {
          title: "AI答疑官",
          level: 2,
          isShow: true,
          componentPageName: "AIAnswer",
          componentIncludeConfig: this.componentIncludeConfigMap.AIAnswer,
          active: false,
          iconActive: false,
          icon: "aiAnswer"
        },
        {
          title: "千人千问",
          level: 2,
          isShow: true,
          hiddenMenu: this.setWeb ? false : true,
          child: [],
          componentPageName: "ThousandQuestion",
          componentIncludeConfig: this.componentIncludeConfigMap
            .ThousandQuestion,
          active: false,
          iconActive: false,
          icon: "thousand"
        },
        {
          title: "智能追问",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "aiAsk",
          componentIncludeConfig: this.componentIncludeConfigMap.aiAsk,
          active: false,
          iconActive: false,
          icon: "aiAsk"
        },
        {
          title: "仪容仪表",
          level: 2,
          isShow: true,
          child: [],
          componentPageName: "appearance",
          componentIncludeConfig: this.componentIncludeConfigMap.appearance,
          active: false,
          iconActive: false,
          icon: "aiAsk"
        }
      ]
    },
    {
      title: "面试间风格",
      level: 1,
      isShow: true,
      componentPageName: "examRoomStyle",
      componentIncludeConfig: this.componentIncludeConfigMap.examRoomStyle,
      active: false
    },
    {
      title: "报告页配置",
      level: 1,
      isShow: true,
      componentPageName: "reportV6",
      componentIncludeConfig: this.componentIncludeConfigMap.reportV6,
      active: false
    },
    {
      title: "报告页配置(旧)",
      level: 1,
      isShow: true,
      componentPageName: "report",
      componentIncludeConfig: this.componentIncludeConfigMap.report,
      active: false
    },
    {
      title: "自定义页配置",
      level: 1,
      isShow: true,
      componentPageName: "customPage",
      componentIncludeConfig: this.componentIncludeConfigMap.customPage,
      active: false
    },
    {
      title: "面试间形象",
      level: 1,
      isShow: true,
      hiddenMenu: this.setWeb ? false : true,
      componentPageName: "examRoomHr",
      componentIncludeConfig: this.componentIncludeConfigMap.examRoomHr,
      active: false
    },
    {
      title: "存储及推流设置",
      level: 1,
      isShow: true,
      hiddenMenu: !(this.setWeb && this.builder !== "MOKA_V2"),
      componentPageName: "storeSet",
      componentIncludeConfig: this.componentIncludeConfigMap.storeSet,
      active: false
    },
    {
      title: "其他设置",
      level: 1,
      isShow: true,
      componentPageName: "otherSet",
      componentIncludeConfig: this.componentIncludeConfigMap.otherSet,
      active: false
    }
  ];

  // 根据配置的 hiddenMenu 动态的展示需要展示的菜单
  get sideList() {
    const temp = this.sideListConfig.filter(v => !v.hiddenMenu);
    temp.forEach(item => {
      if (item.child && item.child.length > 0) {
        item.child = item.child.filter(k => !k.hiddenMenu);
      }
    });
    console.log("🚀 ~ SetOther ~ temp.forEach ~ temp:", temp);
    return temp;
  }

  // 全局增强数据
  globalFunctionalList: GlobalItem[] = [
    {
      componentPageName: "aiWatchingScreen",
      icon: "aiWatching",
      showName: "屏幕监控",
      active: false,
      themeColor: "#ff1111"
    },
    {
      componentPageName: "aiWatchingVideo",
      icon: "aiAsk", // 文件名搞反了
      showName: "视频监控",
      active: false,
      themeColor: "#44a5ff"
    },
    {
      componentPageName: "aiWatchingPolice",
      icon: "police",
      showName: "身份核验",
      active: false,
      themeColor: "#30c833"
    },
    {
      componentPageName: "AIAnswer",
      icon: "aiAnswer",
      showName: "AI答疑官",
      active: false,
      themeColor: "#ffc700"
    },
    {
      componentPageName: "ThousandQuestion",
      icon: "thousand",
      showName: "千人千问",
      active: false,
      themeColor: "#ff6b00"
    },
    {
      componentPageName: "aiAsk",
      icon: "video",
      showName: "智能追问",
      active: false,
      themeColor: "#7857ff"
    }
  ];

  setGlobal({ componentPageName, active }: any) {
    const formItemData = this.getFromPageData({ name: componentPageName });
    const configList = this.componentIncludeConfigMap[componentPageName];
    configList.forEach((key: string) => {
      if (key === "questions") return;

      formItemData[key].use = active ? 1 : 2;
    });
    this.syncBlobalFunctionalStatus(componentPageName);
    const asideBar = this.$refs.asideBar as any;
    if (!asideBar) {
      return;
    }
    this.sideList.forEach((item: any, index: number) => {
      if (item.child?.length) {
        item.child.forEach((child: any, childIndex: number) => {
          if (child.componentPageName === componentPageName) {
            asideBar.clickLeftLv2(child, childIndex, index);
          }
        });
      }
    });
  }

  // 同步侧边栏及预览区全局功能状态
  syncBlobalFunctionalStatus(componentPageName: string) {
    const formItemData = this.getFromPageData({ name: componentPageName });
    const configList = this.componentIncludeConfigMap[componentPageName];
    let active = false;
    configList.forEach((key: string) => {
      if (formItemData[key].use === 1 && key !== "questions") {
        active = true; // 有一个开启就为激活态
      }
    });
    this.sideList.forEach((item: From) => {
      if (item.child && item.child.length) {
        item.child.forEach((child: From) => {
          if (child.componentPageName === componentPageName) {
            child.iconActive = active;
          }
        });
      } else if (item.componentPageName === componentPageName) {
        item.iconActive = active;
      }
    });
    this.globalFunctionalList.forEach(item => {
      if (item.componentPageName === componentPageName) {
        item.active = active;
      }
    });
  }

  // 更新数据
  changeData(componentPageName: string, data: any) {
    if (!data) return;

    this.componentIncludeConfigMap[componentPageName].forEach((key: string) => {
      if (!data[key]) return;

      this.examComponent.examVersionInfo[key] = data[key];
    });
  }

  //所有表单page
  formPageList: FromPage[] = [
    {
      name: "baseInfo",
      src: ""
    }
  ];

  getFormPageList() {
    this.formPageList = [
      {
        name: "baseInfo",
        src: ""
      }
    ];
    this.sideList.forEach(it => {
      if (it.child?.length) {
        it.child.forEach(item => {
          this.formPageList.push({
            name: item.componentPageName || "noName",
            src: ""
          });
        });
      } else {
        this.formPageList.push({
          name: it.componentPageName || "noName",
          src: ""
        });
      }
    });
  }

  componentDataReady = false; //组件数据是否加载完成 不完成组件模版报错

  //获取所有表单数据
  async getAllData() {
    this.$nextTick(() => {
      this.componentDataReady = true;
    });
  }

  //每个表单页面传入数据
  getFromPageData(it: FromPage) {
    //根据name找到对应的数据
    const includeForm = this.componentIncludeConfigMap?.[it.name]; //这里拿到的字段是对应接口里定义的字段
    if (!includeForm || includeForm?.length === 0) return {};
    const data = {};
    includeForm.forEach((name: string) => {
      data[name] = this.examComponent.examVersionInfo[name]; //拿到接口里定义的字段的配置数据
    });
    return data;
  }

  fixedComponentListBefore = ["publicityPageConfig", "privacyConfig"];
  canDragComponentListBefore = [
    "params",
    // 设备检测紧跟着信息收集放
    "deviceDetection",
    "nameIdCheck",
    "livenessRecognition",
    "bgCheck",
    "certPhotoCapture",
    "resumeParseConfig",
    "signatureConfig",
    "descBefore"
  ];
  canDragComponentListAfter = [
    "questions",
    "colorDetection",
    "handDetection",
    "bodyDetection",
    "faceDetection",
    "tacPsycGauge",
    "game"
  ];
  canDragComponentListEnd = ["paramsSaveLater"];
  fixedComponentListEnd = ["descAfter"];

  //拖拽组件源 面试前
  dragComponentListBefore: any = [];
  dragComponentListAfter: any = [];
  dragComponentListEnd: any = [];

  needSetBarStatusComponent = ["handDetection"];
  initSideBar() {
    this.needSetBarStatusComponent.forEach(item => {
      this.setBar({ name: item }, false);
    });
  }

  initGlobalData() {
    this.globalFunctionalList.forEach(item => {
      this.syncBlobalFunctionalStatus(item.componentPageName);
    });
  }

  initDragComponentList(keyList: string[], startSort: number) {
    const list: any[] = [];

    keyList.forEach((name, index) => {
      const comp = this.examComponent.examVersionInfo[name];

      if (!comp) return;

      comp.name = name;
      comp.componentSort = index + startSort;
      list.push(comp);
    });

    return list.sort((a, b) => a.componentSort - b.componentSort);
  }

  initSort() {
    let sort = 1;
    this.initDragComponentList(this.fixedComponentListBefore, sort);

    sort += this.fixedComponentListBefore.length;
    this.dragComponentListBefore = this.initDragComponentList(
      this.canDragComponentListBefore,
      sort
    );

    sort += this.canDragComponentListBefore.length;
    this.dragComponentListAfter = this.initDragComponentList(
      this.canDragComponentListAfter,
      sort
    );

    sort += this.canDragComponentListAfter.length;
    this.dragComponentListEnd = this.initDragComponentList(
      this.canDragComponentListEnd,
      sort
    );

    sort += this.dragComponentListEnd.length;
    this.initDragComponentList(this.fixedComponentListEnd, sort);
  }

  @Watch("examComponent", { deep: true })
  save(n: any, o: any) {
    this.change();
  }

  queryTaskInterval = 0;
  maxRetryCount = 10;
  trailUrl = "";

  // 创建体验二维码
  async createExperienceQrCode() {
    // 切换到手机-》格式转换-》创建任务-》查询体验-》生成二维码
    this.changeRightType(false);
    const taskId = await this.createExperienceTaskByExam();
    let curRetryCount = 0;
    this.queryTaskInterval = setInterval(async () => {
      if (curRetryCount > this.maxRetryCount) {
        clearInterval(this.queryTaskInterval);
        return;
      }
      const process = await this.getExperienceTaskProgress(taskId);
      if (process === 2) {
        clearInterval(this.queryTaskInterval);
        const imageUrl = await this.makeQr(taskId);
        this.trailUrl = imageUrl;
      } else {
        curRetryCount++;
      }
    }, 2000) as any;
  }

  // 体验单个组件
  queryOneTaskInterval = 0;
  async trialOne(componentPageName: keyof typeof EnumTrial) {
    const taskId = await this.createExperienceTaskByExam(componentPageName);
    let curRetryCount = 0;
    this.queryOneTaskInterval = setInterval(async () => {
      if (curRetryCount > this.maxRetryCount) {
        clearInterval(this.queryOneTaskInterval);
        return;
      }
      const process = await this.getExperienceTaskProgress(taskId);
      if (process === 2) {
        clearInterval(this.queryOneTaskInterval);
        const imageUrl = await this.makeQr(taskId);
        this.formPageList.forEach(item => {
          if (item.name === componentPageName) {
            this.$set(item, "src", imageUrl);
          }
        });
        console.log(this.formPageList);
      } else {
        curRetryCount++;
      }
    }, 2000) as any;
  }

  // 根据componet创建体验任务
  async createExperienceTaskByComponent(componentPageName: string) {
    const configData = this.getFromPageData({ name: componentPageName });
    const componentType = this.componentPageNameToComponentType(
      componentPageName
    );
    const res = await request.postInterviewApi("hr/trial/create", {
      processComponents: [{ configData, componentType }],
      functionalComponents: []
    });
    if (res.data.code === 0) {
      return res.data.data.taskId;
    }
    return "";
  }

  // 根据examversion创建体验任务
  async createExperienceTaskByExam(componentPageName?: keyof typeof EnumTrial) {
    const res = await request.postInterviewApi("hr/trial/createByExam", {
      examVersionInfo: this.examComponent.examVersionInfo,
      type: componentPageName ? EnumTrial[componentPageName] : EnumTrial.ALL
    });
    if (res.data.code === 0) {
      return res.data.data.taskId;
    }
    return "";
  }

  // 查询体验任务进度
  async getExperienceTaskProgress(taskId: string) {
    const res = await request.postInterviewApi("public/trial/query", {
      taskId
    });
    if (res.data.code === 0) {
      return res.data.data.progress;
    }
    return 0;
  }

  // 创建二维码
  async makeQr(taskId: string) {
    console.log(process.env.NODE_ENV === "production");
    const res = await request.postInterviewApi("public/common/wsaCode", {
      scene: `${process.env.NODE_ENV === "production" ? 0 : 1}_trail_${taskId}`,
      page: "pages/index/index"
    });

    if (res.data.code !== 0) return "";

    return res.data.data.base64string;
  }

  initDimension() {
    const dimensionGroupList = this.examComponent.examVersionInfo.dimensions
      .dimensionGroupList;
    if (dimensionGroupList.length === 0) {
      const dimensionConfigList = this.examComponent.examVersionInfo.dimensions
        .dimensionConfigList;
      const dimensionGroup = DimensionGroup.getDefaultDimensionGroup(
        dimensionConfigList
      );
      dimensionGroupList.push(dimensionGroup);
    }
  }

  async mounted() {
    this.getFormPageList();
    await this.getAllData();
    this.initSort();
    this.initSideBar();
    this.initGlobalData();
    this.initDimension();
    console.log(this.examComponent, "examComponent");
  }

  prev(i: number) {
    (this.$refs["carousel" + i] as any)?.prev();
  }

  next(i: number) {
    (this.$refs["carousel" + i] as any)?.next();
  }

  @Emit()
  change() {
    return;
  }

  changeTime(val: number) {
    this.examComponent.examVersionInfo.useTimeSecond = val;
  }
}
